



































































import { PropType } from 'vue'
import { Component, Vue  } from "vue-property-decorator";
import Overview from './overview.vue'
import Detailed from './detailed.vue'
import {
  getFlowDetail,
  getFlowStatistics,
  getEmailClickStrategy,
  getFlowMeasureDetail,
  getQueryVariable
} from "@/services/api";
import {TCampaignVO} from "@/model/Campaign";
import { PageInfo } from "@/model/Resp";
import { getPickerOptions, getMonthFirstDay,dateFormat, getWeekFirstDay } from "@/services/common";

interface paneitem {
  label: string;
  value: string;
}

@Component({
  components: {
    "Overview": Overview,
    'Detailed': Detailed
  },
})
export default class wheelOfFortuneList extends Vue {
  tableData: TCampaignVO[] = [];

  flowDetail: any[] = []
  flowDetailname :string = ''
  flowDetailId :number |string | null = null
  flowDetailObj: any = {}

  pageInfo: PageInfo = {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };

  order = null
  prop = null

  totalClickCount = 0
  totalUniqueClickCount = 0

  showTabs:string =  'SendDetailed'


  measureName:string = 'Wait'
  queryEmails:string[] = [];
  queryPhones:string[] = [];

  // date 要随着上一级页面变动
  // 获取url传递过来的date参数
  isNull = getQueryVariable('date') === ',' || getQueryVariable('date') === 'null' || !getQueryVariable('date')
  dateTemp = !this.isNull ? decodeURIComponent(getQueryVariable('date')).split(',') : []
  date = !this.isNull ?  [dateFormat('YYYY-mm-dd 00:00:00', new Date(this.dateTemp[0])), dateFormat('YYYY-mm-dd 00:00:00', new Date(this.dateTemp[1]))] : ['', '']
  pickerOptions = getPickerOptions()
  back() {
    this.$router.back();
  }
  handleCommand(e:any) {
    this.flowDetailname = e.cname
    this.flowDetailId = e.id
    this.getFlowStatistics(e.id as string)
    this.getFlowMeasureDetail(e.id as string)
}

  created(): void {
    this.getFlowDetail()
  }

  //点击发布
  async getEmailClick (){
    let {data ,status} = await getEmailClickStrategy({
      "strategyId": this.flowDetailId,
      dateStart: this.date ? String(this.date[0]).substr(0,10) : dateFormat('YYYY-mm-dd',new Date(new Date().setHours(0, 0, 0, 0) - 30 * 24 * 60 * 60 * 1000)).substr(0,10), // 起始时间
      dateEnd: this.date ? String(this.date[1]).substr(0,10) : dateFormat('YYYY-mm-dd',new Date()).substr(0,10), //截止时间
      "pageSize": this.pageInfo.pageSize,
      "sortColumn": this.prop,
      "sortType": this.order && (this.order === 'ascending'? 'ASC' :'DESC'),
      "currentPage": this.pageInfo.currentPage,
    },true)
    if(status === 200 ){
      this.tableData = data.data.details
      this.totalUniqueClickCount = data.data.totalUniqueClickCount
      this.totalClickCount = data.data.totalClickCount
      this.pageInfo = data.data.pageInfo as PageInfo
    }
  }



  //标题
  async getFlowDetail(){
    if (this.$store.state.flow) {
      this.flowDetail = this.$store.state.flow.strategyUnitList
      this.flowDetailname = this.$route?.query?.cname as string
      this.flowDetailId = this.$route?.query?.id as string
      this.getFlowStatistics(this.flowDetailId as string)
      if(this.showTabs === 'SendDetailed'){
        this.getFlowMeasureDetail(this.flowDetailId as string)
      }else{
        this.getEmailClick()
      }
    }else{
      let {status ,data} =  await getFlowDetail({ id: parseInt(this.$route.params.id) }, true)
      if(status == 200){
        this.flowDetail = data.data.strategyUnitList
        this.flowDetailname = this.$route?.query?.cname as string
        this.flowDetailId = this.$route?.query?.id as string
        this.getFlowStatistics(this.flowDetailId as string)
        if(this.showTabs === 'SendDetailed'){
          this.getFlowMeasureDetail(this.flowDetailId as string)
        }else{
          this.getEmailClick()
        }
      }
    }
  }


  //flow概览
  async getFlowStatistics(id:string, date ?: Date[]){
    if (String(this.$route.params.id) == 'undefined') {
      return
    }
    if (String(id) == 'undefined') {
      return
    }
    let {status ,data} =  await getFlowStatistics({
      strategyIds: [id],
      dateStart: this.date ? this.date[0] : dateFormat('YYYY-mm-dd 00:00:00',new Date(new Date().setHours(0, 0, 0, 0) - 30 * 24 * 60 * 60 * 1000)), // 起始时间
      dateEnd: this.date ? this.date[1] : dateFormat('YYYY-mm-dd 00:00:00',new Date()) //截止时间
       }, true)
    if(status == 200){
      this.flowDetailObj = data?.data[0]
    }
  }


  //flow发送明细
  async getFlowMeasureDetail(id:string){
    if (String(this.$route.params.id) == 'undefined') {
      return
    }
    if (!id) {
      return;
    }
    let params = {
      id: id,
      strategyChannel: this.$route.query.strategyChannel,
      measureName: this.measureName && this.measureName,
      queryEmails: this.queryEmails,
      queryPhones: this.queryPhones,
      sortType: this.order && (this.order === 'ascending'? 'ASC' :'DESC'),
      sortFieldName:  this.order && this.prop,
      dateStart: this.date ? this.date[0] : dateFormat('YYYY-mm-dd 00:00:00',new Date(new Date().setHours(0, 0, 0, 0) - 30 * 24 * 60 * 60 * 1000)), // 起始时间
      dateEnd: this.date ? this.date[1] : dateFormat('YYYY-mm-dd 00:00:00',new Date()), //截止时间
      currentPage: this.pageInfo.currentPage,
      pageSize: this.pageInfo.pageSize
       }
    let {status ,data } =  await getFlowMeasureDetail(params, true)
    if(status == 200){
      this.tableData = data.data
      this.pageInfo = data.pageInfo as PageInfo;
    }
  }

  changeEmail(e:string){
    let a = e.trim()
    if (a.length) {
      this.queryEmails = a.split(/[(\r\n)\r\n,]+/)
    }else{
      this.queryEmails = []
    }
      this.getFlowMeasureDetail(this.flowDetailId as string)
  }

  changePhone(e:string){
    let a = e.trim()
    if (a.length) {
      this.queryPhones = a.split(/[(\r\n)\r\n,]+/)
    }else{
      this.queryPhones = []
    }
    this.getFlowMeasureDetail(this.flowDetailId as string)
  }


  // 时间变化
  changeDate(e:Date[]){
    this.date = e
    this.getFlowStatistics(this.flowDetailId as string ,e)
    if(this.showTabs === 'SendDetailed'){
        this.getFlowMeasureDetail(this.flowDetailId as string)
      }else{
        this.getEmailClick()
      }
  }


  handleClick(e:string){
    // console.log("🚀 ~ file: index.vue:273 ~ wheelOfFortuneList ~ handleClick ~ e", e)
    this.measureName = e
    this.order = null
    this.prop = null
    this.pageInfo.pageSize = 10;
    this.pageInfo.currentPage = 1;
    this.queryEmails = [];
    this.queryPhones = [];
    this.getFlowMeasureDetail(this.flowDetailId as string);
  }

  //发送明细/点击分布
  handShowTabs(val:string){
    this.showTabs =val

    this.order = null
    this.prop = null
    this.pageInfo.pageSize = 10;
    this.pageInfo.currentPage = 1;
    this.queryEmails = [];
    this.queryPhones = [];

    if(this.showTabs === 'SendDetailed'){
      this.getFlowMeasureDetail(this.flowDetailId as string)
    }else{
      this.getEmailClick()
    }
  }

  sortChange(data:any){
    this.order = data?.order
    this.prop = data?.prop
    if(this.showTabs === 'SendDetailed'){
      this.getFlowMeasureDetail(this.flowDetailId as string)
    }else{
      this.getEmailClick()
    }
  }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.pageInfo.pageSize = val;
    this.pageInfo.currentPage = 1;
    if(this.showTabs === 'SendDetailed'){
      this.getFlowMeasureDetail(this.flowDetailId as string)
    }else{
      this.getEmailClick()
    }
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.pageInfo.currentPage = val;
    if(this.showTabs === 'SendDetailed'){
      this.getFlowMeasureDetail(this.flowDetailId as string)
    }else{
      this.getEmailClick()
    }
  }

}
